import React from "react";
import styles from "./footer.module.css";
import whiteLogo from "../../assets/images/whiteLogo.svg";
import facebookIcon from "../../assets/images/facebook.svg";
import linkedInIcon from "../../assets/images/linkedIn.svg";
import instagramIcon from "../../assets/images/instagram.svg";
import youtubeIcon from "../../assets/images/youtoube.svg";
import twitterIcon from "../../assets/images/twitter.svg";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.section}>
          <img src={whiteLogo} alt="CFH Logo" className={styles.logo} />
          <div className={styles.socialMedia}>
            <a
              href="https://www.linkedin.com/company/cairo-financial-holding-cfh/"
              className={styles.icon}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={linkedInIcon} alt="" />
            </a>
          </div>
        </div>
        <div className={styles.boderRight}></div>
        <div className={styles.section}>
          <h3>Site Map</h3>
          <ul>
            <li>
              <Link to="/about-us">Our Firm</Link>
            </li>
          </ul>
        </div>
        <div className={styles.boderRight}></div>

        <div className={styles.section}>
          <h3>Company</h3>
          <ul>
            <li>
              <Link to="/contact-us">Contact us</Link>
            </li>
            <li>
              <Link to="/careers">Careers</Link>
            </li>
          </ul>
        </div>
        <div className={styles.boderRight}></div>

        <div className={styles.section}>
          <h3>Contact us</h3>
          <address>
            7 Lazoghli street, Garden City, Cairo, Egypt
            <br />
            +20227924281
            <br />
            <a href="mailto:info@cf-holding.com" className={styles.anchor}>
              info@cf-holding.com
            </a>
          </address>
        </div>
      </div>
      <div className={styles.copyright}>
        © Copyright Cairo Financial Holding All Rights Reserved.
      </div>
    </div>
  );
};

export default Footer;
